import { Icon, IconProps } from 'almanac-ui/icons/Types'
import { RevisionType } from 'components/BlazeCommandLine/Types'
import { BrandVoice, ChangeLength } from 'almanac-ui/icons'
import { AI } from 'blaze-ui/icons'

interface Props extends IconProps {
  revisionType: RevisionType
  defaultIcon?: Icon
}

export const RevisionTypeIcon = ({ revisionType, size = 16, defaultIcon: DefaultIcon = AI, ...rest }: Props) => {
  const iconProps = { size, ...rest }
  switch (revisionType) {
    case RevisionType.CUSTOM_PROMPT:
      return <DefaultIcon {...iconProps} />
    case RevisionType.CHANGE_TONE:
      return <BrandVoice {...iconProps} />
    case RevisionType.CHANGE_LENGTH:
      return <ChangeLength {...iconProps} />
    default:
      return <DefaultIcon {...iconProps} />
  }
}
